export const getCounterTextClassnames = (
  type: string,
  length: number,
  slugValid?: boolean
) => {
  switch (type) {
    case 'title':
      if (length >= 1 && length <= 60) {
        return 'success'
      }
      if (length > 60 && length < 80) {
        return 'warning'
      }
      if (length > 80) {
        return 'error'
      }
      break
    case 'description':
      if (length >= 50 && length <= 160) {
        return 'success'
      }
      if ((length >= 1 && length <= 49) || length > 160) {
        return 'warning'
      }
      break
    case 'slug':
      if (!slugValid) {
        return 'error'
      }
      if (length > 25) {
        return 'warning'
      }
      if (length >= 1 && length <= 25) {
        return 'success'
      }
      break
    default:
      return 'success'
  }
}
